export const MY_TABLES_EVENT = 'nhex:open-my-tables'

export function openMyTables(tableLimitReached = false): void {
  window.dispatchEvent(new CustomEvent(MY_TABLES_EVENT, { detail: { tableLimitReached } }))
}
